// Static text pool for Træningsbane — full alphabet, no key filtering.

import { FLOW_CHUNKS_DA } from '../data/flowPractice/chunks-da';
import { FLOW_CHUNKS_EN } from '../data/flowPractice/chunks-en';
import { makeRng } from '../data/curriculum/generators';
import type { FlowLexicon } from '../types';
import { FLOW_PASSAGE_MIN_CHARS } from './flowPractice';

export interface FlowChunkPick {
  text: string;
  topic: string;
}

function poolForLexicon(lexicon: FlowLexicon): FlowChunkPick[] {
  const curated = lexicon === 'en' ? FLOW_CHUNKS_EN : FLOW_CHUNKS_DA;
  return curated.filter((c) => c.text.length >= FLOW_PASSAGE_MIN_CHARS);
}

export function pickFlowChunkStatic(
  lexicon: FlowLexicon,
  excludeTopics: ReadonlyArray<string> = [],
  seed?: number,
): FlowChunkPick {
  const rng = makeRng(seed);
  const exclude = new Set(excludeTopics);
  let pool = poolForLexicon(lexicon).filter((c) => !exclude.has(c.topic));
  if (pool.length === 0) {
    pool = poolForLexicon(lexicon);
  }
  return pool[Math.floor(rng() * pool.length)]!;
}

export function pickInitialFlowPassage(
  lexicon: FlowLexicon,
  seed?: number,
): FlowChunkPick {
  return pickFlowChunkStatic(lexicon, [], seed);
}

export function pickInitialFlowText(
  lexicon: FlowLexicon,
  seed?: number,
): string {
  return pickInitialFlowPassage(lexicon, seed).text;
}
